<ng-container [formGroup]="parentFormGroup">
  <div class="mt-3 ms-2 mb-3 chip-control">
    <div class="d-flex align-items-center gap-2 mb-2">
      @if (currentConfig.displayText) {
        <span class="mat-body-medium">{{ currentConfig.displayText }}</span>
      }
      <ra-tooltip
        class="ms-1"
        [tooltipConfig]="currentConfig?.tooltipConfig"
      ></ra-tooltip>
      @if (currentConfig.loading || showSpinner) {
        <mat-spinner [diameter]="22" class="chip-control-spinner"></mat-spinner>
      }
    </div>
    @if (resolvedHintLabel) {
      <p class="text-muted mb-2 chip-control__hint">{{ resolvedHintLabel }}</p>
    }
    @if (chipOptionSearchEnabled) {
      <ra-search-bar-field
        class="chip-control-search mb-2"
        [(ngModel)]="chipSearchTerm"
        [ngModelOptions]="{ standalone: true }"
        [label]="currentConfig.chipOptionSearchLabel ?? ''"
        [placeholder]="currentConfig.chipOptionSearchPlaceholder ?? ''"
        [disabled]="chipOptions.length === 0"
      />
    }
    <mat-chip-listbox
      [formControlName]="currentConfig.property"
      [multiple]="isMultiple"
      [selectable]="!readOnly"
      [disabled]="readOnly"
      [required]="!!currentConfig?.validators?.required"
      [ngClass]="{ 'ui-disabled': readOnly }"
      (change)="onChipListChange()"
    >
      @for (opt of displayChipOptions; track opt.value) {
        <mat-chip-option [value]="opt.value">{{ opt.label }}</mat-chip-option>
      }
    </mat-chip-listbox>
    @if (parentFormGroup?.get(currentConfig.property)?.errors) {
      <mat-error class="mt-1 d-block">
        {{
          currentConfig?.errorMessages?.[
            keys(parentFormGroup?.get(currentConfig.property)?.errors)?.[0]
          ] || "Please review the field"
        }}
      </mat-error>
    }
    @if (!readOnly) {
      <div
        class="chip-control-actions d-flex flex-wrap align-items-center gap-2 mb-2"
      >
        @if (isMultiple) {
          <button
            type="button"
            class="ra-blue-btn mat-mdc-raised-button chip-control-action-btn"
            [disabled]="isSelectAllDisabled"
            (click)="onSelectAll()"
          >
            Select All
          </button>
        }
        <button
          type="button"
          class="ra-blue-btn mat-mdc-raised-button chip-control-action-btn"
          [disabled]="isClearDisabled"
          (click)="onClearAll()"
        >
          Clear
        </button>
        <button
          type="button"
          class="ra-blue-btn mat-mdc-raised-button chip-control-action-btn"
          [disabled]="isResetToDefaultsDisabled"
          (click)="onResetToDefaults()"
        >
          Reset to defaults
        </button>
      </div>
    }
  </div>
</ng-container>
